export const setValue = (value) => Object.freeze({
    isSet: true,
    value,
});
export const emptyValue = Object.freeze({
    isSet: false,
});
